<template>
    <div id="app">
        <Header></Header>
        <div class="bodyHeight">
            <loginModule></loginModule>
            <registerModule></registerModule>
            <FindPassword></FindPassword>
            <ModifyPassword></ModifyPassword>
            <router-view></router-view>
        </div>
        <Footer></Footer>
    </div>
</template>

<style lang="scss">
* {
    padding: 0;
    margin: 0;
}
.bodyHeight {
    min-height: 600px;
    overflow: auto;
}
</style>
<script>
import Header from "@/layout/header.vue";
import Footer from "@/layout/footer.vue";
import loginModule from "./views/login/login.vue";
import registerModule from "./views/register/register.vue";
import FindPassword from "./views/find-password/find-password.vue";
import ModifyPassword from "./views/modify-password/modify-password.vue";
export default {
    name: "App",
    components: { Header, Footer, loginModule, registerModule, FindPassword, ModifyPassword },
    data() {
        return {};
    },
    methods: {},
};
</script>
